import { render, staticRenderFns } from "./plDerated.vue?vue&type=template&id=72bbc23a&scoped=true&"
import script from "./plDerated.vue?vue&type=script&lang=js&"
export * from "./plDerated.vue?vue&type=script&lang=js&"
import style0 from "./plDerated.vue?vue&type=style&index=0&id=72bbc23a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bbc23a",
  null
  
)

export default component.exports